/**
 * Deep equality comparison that works in both browser and Node.js environments.
 * Handles primitives, arrays, plain objects, Date, RegExp, and null/undefined.
 */
export function deepEqual(first: unknown, second: unknown): boolean {
    if (first === second) return true;
    if (first === null || second === null) return false;
    if (first === undefined || second === undefined) return false;
    if (typeof first !== typeof second) return false;

    if (first instanceof Date && second instanceof Date) {
        return first.getTime() === second.getTime();
    }

    if (first instanceof RegExp && second instanceof RegExp) {
        return first.toString() === second.toString();
    }

    if (typeof first !== 'object' || typeof second !== 'object') return false;

    if (Array.isArray(first) !== Array.isArray(second)) return false;

    const keysFirst = Object.keys(first as Record<string, unknown>);
    const keysSecond = Object.keys(second as Record<string, unknown>);

    if (keysFirst.length !== keysSecond.length) return false;

    const objectFirst = first as Record<string, unknown>;
    const objectSecond = second as Record<string, unknown>;

    for (const key of keysFirst) {
        if (!Object.prototype.hasOwnProperty.call(objectSecond, key)) return false;
        if (!deepEqual(objectFirst[key], objectSecond[key])) return false;
    }

    return true;
}
